import * as React from "react";
import { LayoutIndex } from "../components/layout";
import { Link } from "gatsby";
import { SEO } from "../components/seo";
export default () => (<LayoutIndex>
    <SEO title="Home"/>
    <div className="px-8 py-4">
      <article>
        <h1>
          <Link to="/basics" className="text-blue no-underline hover:underline">
            IME Basics
          </Link>
        </h1>
        <p>Learn how to type.</p>
      </article>
    </div>
  </LayoutIndex>);
//# sourceMappingURL=index.jsx.map